













































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { FamilyReport } from '@/interfaces/Models';

@Component
export default class FamilyReportForm extends Vue {

    @Prop() dialog!: boolean;
    @Prop() resource!: any | null;

    public familyReport: FamilyReport = {
        id: 0,
        meal_notes: '',
        breakfast: false,
        morning_snack: false,
        lunch: false,
        afternoon_snack: false,
        dinner: false,
        evening_snack: false,
        activity_notes: '',
        free_play: false,
        crafts: false,
        story_time: false,
        tv_movies: false,
        outside: false,
        field_trip: false,
        rest_notes: '',
        naps: false,
        bedtime: false,
        learning_notes: '',
        new_words: false,
        skills: false,
        behaviors: false,
        family_notes: '',
    }
    
    public get resourceIsSet(): boolean {
        if ( this.familyReport.id > 0 ) {
            return true;
        }
        return false;
    }

    public $refs!: {
        form: HTMLFormElement // fix for this.$refs.form.valdiate(); TS error
    }
    
    public close() {
        this.$emit('update:dialog', !this.dialog);
    }

    public save() {

        let path = this.resourceIsSet ? api.path('v1.b.familyReports.single', { id: this.familyReport.id }) : api.path('v1.b.familyReports');

        let payload = {
            babysitting_session_report_id: this.resource.id,
            ...this.familyReport
        }
        
        if ( this.resourceIsSet ) {
            axios.patch(path, payload)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.resource.family_report = { ...this.familyReport };
                });
        } else {
            axios.post(path, payload)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.resource.family_report = { ...this.familyReport, id: res.data.data.id };
                });
        }
    }

    @Watch('resource')
    onResourceChange(babysittingSessionReport: any) {
        this.familyReport = { ...babysittingSessionReport?.family_report };
    }
}
